import React from "react";

export default function Web_Fullstack_JS() {
  return (
    <div>
      <h1>What is Fullstack JS</h1>
      <p>
        Route: <code>/web/fullstack-js</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
